export default {
	sec_10: {
		title: {
			one: 'Sell ​​crypto assets',
		},
		desc: {
			one: 'Are you having trouble selling your crypto assets?',
			two: 'Still waiting for a buyer?',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_11: {
		one: {
			title: {
				one: 'Selling crypto assets ',
				two: 'has never been easier',
			},
			desc: {
				one: 'Customer-to-Customer Sales: Sell directly to JP WORLD Pay.',
				two: 'Sell in your preferred way.',
			},
		},
		two: {
			title: {
				one: 'Exchange rates are automatically ',
				two: 'applied with the push of a button',
			},
			desc: {
				one: 'With a single click, the current market price is automatically applied, allowing you to sell immediately.',
			},
		},
	},
};
